import styled from 'styled-components'

export const Wrapper = styled.div`
  aspect-ratio: 16/9;
`

Wrapper.displayName = 'Wrapper'
